import { render, staticRenderFns } from "./BaseNotifications.vue?vue&type=template&id=b7a7b604&"
import script from "./BaseNotifications.vue?vue&type=script&lang=js&"
export * from "./BaseNotifications.vue?vue&type=script&lang=js&"
import style0 from "./BaseNotifications.vue?vue&type=style&index=0&id=b7a7b604&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7a7b604')) {
      api.createRecord('b7a7b604', component.options)
    } else {
      api.reload('b7a7b604', component.options)
    }
    module.hot.accept("./BaseNotifications.vue?vue&type=template&id=b7a7b604&", function () {
      api.rerender('b7a7b604', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Notification/BaseNotifications.vue"
export default component.exports